import PlanBilling from "../../indi-plan/plan-billing";

function SlidePayment() {
    return (
        <div id="uo-payment" className="uo-component">
            <PlanBilling withHeader={false} withCustomModal={false} />
        </div>
    );
}

export default SlidePayment;